import { makeFinalRequest, makePutRequest } from '../general/general-service';

export function sendComment (programId, comment) {
	const finalRequestUrl = makeFinalRequest(`interaction/comment/${programId}`);
	return makePutRequest(finalRequestUrl, {
		comment: comment
	});
}